import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DescriptionIcon from "@material-ui/icons/Description";
import {
  blue,
  orange,
  lime,
  green,
  red,
  purple,
} from "@material-ui/core/colors";
import {
  bandejaLimpiar,
  fetchBandejaPorEstado,
  fetchBandejaPorEstados,
} from "../../../actions/bandeja";
import { estados } from "../../../helpers/estados";
//import { HubConnectionBuilder } from "@microsoft/signalr";

const useStyles = makeStyles({
  rootButtons: {
    textAlign: "end",
    marginRight: 30,
    marginLeft: 30,
    borderBottom: "1px solid #ddd2d2de",
  },
  button: {
    textTransform: "none",
    fontSize: 10,
    border: "1px solid #ddd2d2de",
    borderBottom: "4px solid white",
  },
  TypographyClasses: {
    textDecoration: "none",
    color: "black",
  },
});

const estilosEstadoPreAfiliado = {
  /* backgroundColor: "rgba(0, 0, 0, 0.04)", Este es el tono gris del hover*/
  backgroundColor: "#eceaea",
};

export const Estados = ({
  esAreaUno,
  idArea,
  setTextoBuscado,
  idSeccional,
  onClickEstado,
  ...props
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { cantidades } = useSelector((state) => state.bandeja);

  // const baseUrl = process.env.REACT_APP_URL;
  // useEffect(() => {
  //   const connection = new HubConnectionBuilder()
  //     .withUrl(`${baseUrl}/hubs/logs`)
  //     .withAutomaticReconnect()
  //     .build();
  //   connection
  //     .start()
  //     .then((result) => {
  //       console.log("Connected Bandeja!");

  //       connection.on("ReceiveCountersBandeja", (counters) => {
  //         dispatch(contadoresFitrado(counters));
  //       });
  //     })
  //     .catch((e) => console.log("Connection failed: ", e));
  // }, [baseUrl, dispatch]);

  const cant = {
    estado8: cantidades.find(
      (s) => s.idEstado === estados.Preafiliacion_PresencialNuevo
    )?.total,
    estado9: cantidades.find(
      (s) => s.idEstado === estados.Preafiliacion_PresencialIngresada
    )?.total,
    estado10: cantidades.find(
      (s) => s.idEstado === estados.Preafiliacion_BandejaSeccional
    )?.total,
    estado11: cantidades.find(
      (s) => s.idEstado === estados.Preafiliacion_BandejaSeccionalModificada
    )?.total,
    estado29: cantidades.find(
      (s) => s.idEstado === estados.Preafiliacion_BandejaNacionalObservada
    )?.total,
    estado20: cantidades.find(
      (s) => s.idEstado === estados.Preafiliacion_BandejaNacional
    )?.total,
    estado19: cantidades.find(
      (s) => s.idEstado === estados.Preafiliacion_BandejaSeccionalObservada
    )?.total,
    estado21: cantidades.find(
      (s) => s.idEstado === estados.Preafiliacion_BandejaNacionalModificada
    )?.total,
    estado30: cantidades.find(
      (s) => s.idEstado === estados.Preafiliacion_BandejaNacionalAprobada
    )?.total,
  };
  //console.log('cantidades',cant);
  const handleTraerXEstado = (area, idEstado) => {
    setTextoBuscado("");
    dispatch(bandejaLimpiar());
    dispatch(fetchBandejaPorEstado(area, idEstado, idSeccional));
  };
  const handleTraerEstados = (listaEstados, area) => {
    setTextoBuscado("");
    dispatch(bandejaLimpiar());
    dispatch(fetchBandejaPorEstados(listaEstados, idSeccional, area));
  };
  return (
    <div className={classes.rootButtons}>
      {/* BANDEJA DE SECCIONAL */}
      {/* contactos web solo seccional */}
      {esAreaUno && (
        <Button
          className={classes.button}
          color="inherit"
          onClick={() => {
            handleTraerEstados(
              `${estados.Preafiliacion_PresencialNuevo},${estados.Preafiliacion_BandejaSeccional},${estados.Preafiliacion_BandejaSeccionalModificada},${estados.Preafiliacion_BandejaSeccionalObservada}`,
              idArea
            );
            onClickEstado("En Carga");
          }}
          style={
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_PresencialNuevo ||
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaSeccional ||
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaSeccionalModificada
              ? estilosEstadoPreAfiliado
              : null
          }
        >
          <DescriptionIcon style={{ color: orange[500] }} fontSize="large" />
          {!isNaN(
            parseInt(cant.estado8) +
              parseInt(cant.estado11) +
              parseInt(cant.estado10) +
              parseInt(cant.estado19) 
          )
            ? parseInt(cant.estado8) +
              parseInt(cant.estado11) +
              parseInt(cant.estado10) +
              parseInt(cant.estado19)
            : 0}{" "}
          {"En Carga"}
        </Button>
      )}

      {esAreaUno && (
        <Button
          className={classes.button}
          color="inherit"
          onClick={() => {
            handleTraerXEstado(
              idArea,
              esAreaUno
                ? estados.Preafiliacion_BandejaNacionalObservada
                : estados.Preafiliacion_BandejaNacionalModificada
            );
            onClickEstado("Devolucion Nacional");
          }}
          style={
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaNacionalObservada ||
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaNacionalModificada
              ? estilosEstadoPreAfiliado
              : null
          }
        >
          <DescriptionIcon style={{ color: lime[500] }} fontSize="large" />
          {cant.estado29 ?? 0} {"Devolucion Nacional"}
        </Button>
      )}
      {esAreaUno && (
        <Button
          className={classes.button}
          color="inherit"
          onClick={() => {
            handleTraerEstados(
              `${estados.Preafiliacion_PresencialIngresada},${estados.Preafiliacion_BandejaNacional},${estados.Preafiliacion_BandejaNacionalModificada}`,
              idArea
            );
            onClickEstado("Enviadas");
          }}
          style={
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_PresencialIngresada ||
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaNacional ||
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaNacionalModificada ||
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaNacionalAprobada
              ? estilosEstadoPreAfiliado
              : null
          }
        >
          <DescriptionIcon style={{ color: purple[500] }} fontSize="large" />
          {!isNaN(
            parseInt(cant.estado9) +
              parseInt(cant.estado20) +
              parseInt(cant.estado21) +
              parseInt(cant.estado30)
          )
            ? parseInt(cant.estado9) +
              parseInt(cant.estado20) +
              parseInt(cant.estado21) +
              parseInt(cant.estado30)
            : 0}{" "}
          {"Enviadas"}
        </Button>
      )}
      
      {esAreaUno && (
        <Button
          className={classes.button}
          color="inherit"
          onClick={() => {
            handleTraerXEstado(
              idArea,
              estados.Preafiliacion_BandejaNacionalAprobada
            );
            onClickEstado("Aceptadas");
            props.estadoPreAfiliadoHandler(
               estados.Preafiliacion_BandejaNacionalAprobada
            );
          }}
          style={
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaNacionalAprobada
              ? estilosEstadoPreAfiliado
              : null
          }
        >
          <DescriptionIcon style={{ color: green[500] }} fontSize="large" />
          {cant.estado30 ?? 0} {"Aceptadas"}
        </Button>
      )}
  
      {/* BANDEJA DE NACIONAL */}
      {!esAreaUno && (
        <Button
          className={classes.button}
          color="inherit"
          onClick={() => {
            handleTraerEstados(
              `${estados.Preafiliacion_PresencialIngresada},${estados.Preafiliacion_BandejaNacional},${estados.Preafiliacion_BandejaNacionalModificada}`,
              idArea
            );
            onClickEstado("Ingresadas Seccional");
            props.estadoPreAfiliadoHandler(
              esAreaUno
                ? estados.Preafiliacion_BandejaNacionalModificada
                : estados.Preafiliacion_BandejaSeccionalModificada
            );
          }}
          style={
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_PresencialIngresada ||
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaNacional ||
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaNacionalModificada
              ? estilosEstadoPreAfiliado
              : null
          }
        >
          <DescriptionIcon style={{ color: blue[500] }} fontSize="large" />
          {!isNaN(
            parseInt(cant.estado9) +
              parseInt(cant.estado20) +
              parseInt(cant.estado21)
          )
            ? parseInt(cant.estado9) +
              parseInt(cant.estado20) +
              parseInt(cant.estado21)
            : 0}{" "}
          {"Ingresadas Seccional"}
        </Button>
      )}

      {!esAreaUno && (
        <Button
          className={classes.button}
          color="inherit"
          onClick={() => {
            handleTraerXEstado(
              idArea,
              esAreaUno
                ? estados.Preafiliacion_BandejaNacional
                : estados.Preafiliacion_BandejaNacionalAprobada
            );
            onClickEstado("Aceptadas");
            props.estadoPreAfiliadoHandler(
              esAreaUno
                ? estados.Preafiliacion_BandejaNacional
                : estados.Preafiliacion_BandejaNacionalAprobada
            );
          }}
          style={
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaNacional ||
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaNacionalAprobada
              ? estilosEstadoPreAfiliado
              : null
          }
        >
          <DescriptionIcon style={{ color: green[500] }} fontSize="large" />
          {cant.estado30 ?? 0} {"Aceptadas"}
        </Button>
      )}
      {!esAreaUno && (
        <Button
          className={classes.button}
          color="inherit"
          onClick={() => {
            handleTraerXEstado(
              idArea,
              esAreaUno
                ? estados.Preafiliacion_BandejaSeccionalObservada
                : estados.Preafiliacion_BandejaNacionalObservada
            );
            onClickEstado("Observadas");
            props.estadoPreAfiliadoHandler(
              esAreaUno
                ? estados.Preafiliacion_BandejaSeccionalObservada
                : estados.Preafiliacion_BandejaNacionalObservada
            );
          }}
          style={
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaSeccionalObservada ||
            props.estadoPreAfiliadoSeleccionado ===
              estados.Preafiliacion_BandejaNacionalObservada
              ? estilosEstadoPreAfiliado
              : null
          }
        >
          <DescriptionIcon style={{ color: red[500] }} fontSize="large" />
          {cant.estado29 ?? 0} Observadas
        </Button>
      )}
    </div>
  );
};
